import { useTranslationLang, useTranslationRoute, useTranslations } from "@bsm/component";
import { useMemo } from "react";

export const useLeftSideBarMenuAdminManagement = () => {

    const [
        ADMIN_MANAGEMENT,
        PAYSLIP,
        CONTRACTS,
        ABSCENSE,
        SOCIAL_STATEMENT
    ] = useTranslations(i18n)
    const translationRoute = useTranslationRoute();
    const { lang } = useTranslationLang()

    return useMemo(() => ({
        ke: "general",
        label: ADMIN_MANAGEMENT,
        className: "menu-item-category",
        items: [
            // {
            //     label: CONTRACTS,
            //     startIcon: "fa-solid fa-person",
            //     link: translationRoute("admin/contract"),
            //     roles: ["CONTRACT"],
            // },
            // {
            //     label: PAYSLIP,
            //     startIcon: "fa-solid fa-clipboard-list",
            //     link: translationRoute("admin/payslips"),
            //     roles: ["PAYING_SLIP"],
            // },
            {
                label: ABSCENSE,
                startIcon: "fa-solid fa-person-skating",
                link: translationRoute("admin/project/dayoff/demand"),
                roles: ["TIMEOFF"],
            },
            // {
            //     label: SOCIAL_STATEMENT,
            //     link: translationRoute("admin/payslips/social-statement"),
            //     roles: ["PAYING_SLIP_SOCIALS"],
            //     startIcon: "fa-solid fa-file",
            // }
        ],
    }), [lang])
}

const i18n = [
    'BSMRH.Admin.LeftSideBar.Menu.AdminManagement.Label',
    'BSMRH.Admin.LeftSideBar.Menu.AdminManagement.Payslip.Label',
    'BSMRH.Admin.LeftSideBar.Menu.AdminManagement.Contracts.Label',
    'BSMRH.Admin.LeftSideBar.Menu.AdminManagement.Abscense.Label',
    "BSMRH.Payslip.Menu.Label.Social.Statement",
]
